/**
 * Ukrainian Flag Icon
 */
import React from 'react';

interface FlagUaIconProps {
  width?: number;
  height?: number;
  className?: string;
}

const FlagUaIcon: React.FC<FlagUaIconProps> = ({
  width = 24,
  height = 18,
  className = '',
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`flag-icon flag-icon--ua ${className}`}
    >
      <rect width="24" height="18" rx="2" fill="#FFD700" />
      <rect width="24" height="9" rx="2" fill="#005BBB" />
    </svg>
  );
};

export default FlagUaIcon;
